import { render } from "./delete-request.vue?vue&type=template&id=e0ae73b4"
import script from "./delete-request.vue?vue&type=script&lang=js"
export * from "./delete-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__